import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=66e178f6&scoped=true&"
import script from "@/views/Roster/Holiday.ts?vue&type=script&lang=ts&"
export * from "@/views/Roster/Holiday.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Roster/holiday.scss?vue&type=style&index=0&id=66e178f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e178f6",
  null
  
)

export default component.exports